<template>
  <div id="preview">
    <v-toolbar color="#8950FC">
      <v-toolbar-title>
        <h1 class="text-white">{{ pageTitle }}</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <!-- <small>*indicates required field</small> -->
        <v-container v-if="SearchFlag">
          <div class="d-flex justify-content-center mb-3">
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </div>
        </v-container>
        <v-container v-if="OtpSendFlag == false">
          <v-card>
            <v-form
              ref="form1"
              v-model="valid1"
              lazy-validation
              v-on:submit.prevent="sendOtp"
            >
              <v-card-title>
                <span class="headline">Member Aadhar number Verification</span>
              </v-card-title>
              <v-card-text>
                <!-- <small>*indicates required field</small> -->
                <v-row v-if="!OtpSendFlag">
                  <v-col cols="12" sm="6" md="4">
                    <h6>
                      <span class="text-danger">*</span> Enter Your Aadhar
                      Number
                    </h6>
                    <v-text-field
                      v-model="AadharNo"
                      :rules="AadharNoRules"
                      outlined
                      v-mask="'####-####-####'"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="!OtpSendFlag">
                  <v-col align="center" cols="12" sm="12" md="12">
                    <v-btn
                      v-if="SendOtpButtonFlag"
                      type="submit"
                      :disabled="!valid1"
                      @click.prevent="sendOtp"
                      :loading="SendOtpLoadingFlag"
                      target="_blank"
                      color="#ff7f50"
                      class="text-white"
                    >
                      Send OTP
                    </v-btn>
                    <v-btn
                      type="submit"
                      @click.prevent="getDigilockerUrl"
                      :loading="SubmitFlag"
                      target="_blank"
                      color="#ff7f50"
                      class="text-white"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-container>
        <v-container v-if="OtpSendFlag == true && VerifyOtpFlag == false">
          <v-card>
            <v-form
              ref="form2"
              v-model="valid2"
              lazy-validation
              v-on:submit.prevent="verifyOtp"
            >
              <v-card-title>
                <span class="headline">Verify OTP</span>
              </v-card-title>
              <v-card-text>
                <!-- <small>*indicates required field</small> -->
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <label>OTP</label>
                    <v-text-field
                      v-model="VerificationCode"
                      :rules="VerificationCodeRules"
                      :counter="6"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col align="center" cols="12" sm="12" md="12">
                    <v-btn
                      type="submit"
                      :disabled="!valid2"
                      @click.prevent="verifyOtp"
                      :loading="VerifyOtpLoadingFlag"
                      target="_blank"
                      color="#8950FC"
                      class="text-white"
                    >
                      <!-- <v-icon dark> mdi-file-excel </v-icon> -->
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn
            @click="closePrompt"
            elevation="30"
            shaped
            tile
            small
            color="#a52a2a"
            class="font-size-h6 px-10 mr-3 white--text"
          >
            Close
          </v-btn> -->
      </v-card-actions>
    </v-card>
  </div>
</template>


<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageId: {
      required: false,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      valid3: true,

      LoadingFlag: false,
      SearchFlag: false,
      ResultFlag: false,

      AadharNo: "",
      AadharNoRules: [(v) => !!v || "Aadhaar number is required"],

      VerificationCode: "",
      VerificationCodeRules: [(v) => !!v || "OTP is required"],

      OtpSendFlag: false,
      VerifyOtpFlag: false,
      SubmitFlag: false,

      SendOtpButtonFlag: false,

      SendOtpLoadingFlag: false,
      VerifyOtpLoadingFlag: false,
      SubmitLoadingFlag: false,

      pageTitle: "Add / Update Aadhar number",
      pageDescription: "",

      pageContent: "",

      rows: [],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      MobileNo: "",
      MobileNoRules: [(v) => !!v || "Mobile number is required"],

      NewPassword: "",
      NewPasswordRules: [(v) => !!v || "New password is required"],

      ConfirmPassword: "",
      ConfirmPasswordRules: [(v) => !!v || "Confirm password is required"],

      RefId: "",
    };
  },
  computed: {
    // This function returns the AadharNo without any dashes
    formattedAadharNo() {
      // Replace all dashes in the AadharNo with an empty string
      return this.AadharNo.replace(/-/g, "");
    },
  },
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      //   this.$refs.ProfilePicture.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var pageId = this.pageId;
      console.log("pageId=" + pageId);
      //   this.getMemberDetails();
    },
    getDigilockerUrl() {
      console.log("getDigilockerUrl is called");

      var validate1 = true;
      console.log("validate1=" + validate1);

      this.ResultFlag = false;

      if (validate1) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/aadhaar/digilocker-url";
        var upload = {
          UserInterface: 1,
          AadhaarNumber: this.formattedAadharNo,
          VerificationId: this.VerificationId,
        };
        console.log("upload=" + JSON.stringify(upload));

        this.SubmitFlag = true;

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = true;

            flag = response.data.flag;
            output = response.data.output;
            console.log("flag=" + flag + ", output=" + output);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              var url = records.url;
              console.log("url=" + url);

              const popup = window.open(
                url,
                "Digilocker",
                "width=900,height=700"
              );
              // Poll to check if popup is closed
              const checkClosed = setInterval(() => {
                if (popup.closed) {
                  clearInterval(checkClosed);
                  thisIns.ResultFlag = true;
                  thisIns.closePrompt();
                }
              }, 1000);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            // thisIns.toast("error", "Something went wrong");
          });
      }
    },
    sendOtp() {
      console.log("sendOtp is called");

      var validate = this.$refs.form1.validate();
      console.log("validate=" + validate);
      /*
      validate = false;
      this.SendOtpLoadingFlag = true;
      setTimeout(() => {
        this.SendOtpLoadingFlag = false;
        this.OtpSendFlag = true;
      }, 2000);
      */

      if (validate == true) {
        this.SendOtpLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/aadhaar/send-otp";
        var upload = {
          UserInterface: 1,
          AadhaarNumber: this.formattedAadharNo,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SendOtpLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.OtpSendFlag = true;
              thisIns.RefId = records.ref_id;
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SendOtpLoadingFlag = false;
          });
      } else {
        var message = "";
        if (validate == false) {
          message += "Kindly fill the required fields. ";
        }
        this.sweetAlert("error", message, false);
      }
    },

    verifyOtp() {
      console.log("verifyOtp is called");

      var validate = this.$refs.form2.validate();
      console.log("validate=" + validate);

      if (validate == true) {
        this.VerifyOtpLoadingFlag = true;
        this.ResultFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/aadhaar/verify-otp";
        var upload = {
          UserInterface: 1,
          Otp: this.VerificationCode,
          ReferenceId: this.RefId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.VerifyOtpLoadingFlag = false;
            // thisIns.ShowFormFlag = true;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
              // thisIns.MemberTypeId = 23;
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.VerifyOtpLoadingFlag = false;
          });
      } else {
        var message = "";
        if (validate == false) {
          message += "Kindly fill the required fields. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
